<template>
  <div class="single">
    <div class="row">
      <label class="col-sm-3 control-label pt-10"> Appointment Date* </label>
      <div class="col-sm-8">
        <DatePicker
          v-model="data.scheduledAppointmentDate"
          required
          :disabled-date="disabledDate"
        />
      </div>
    </div>

    <div class="row">
      <label class="control-label pt-10 col-sm-3"> Appointment Time* </label>
      <TimePicker
        v-model="data.scheduledAppointmentTime"
        class="col-sm-8"
        required
        clearable
        format="hh:mm a"
        @blur="changePickupTime"
      >
        <template #comment>
          <span
            v-if="isShowTimeWarningMessage"
            class="help-block warning-message"
          >
            Please inform the rider that it may be hard to get a driver at this scheduled time.
          </span>
        </template>
      </TimePicker>
    </div>

    <div class="row">
      <label class="control-label pt-10 col-sm-3"> Arrive Minutes Early* </label>
      <div class="col-sm-8">
        <NumberInput
          v-model="data.scheduledAppointmentBufferMinutes"
          class="form-control"
          required
          min="0"
          type="number"
          :step="1"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import NumberInput from '@/components/UIComponents/NumberInput.vue'
import TimePicker from '@/components/UIComponents/TimePicker.vue'
import DatePicker from '@/components/UIComponents/DatePicker.vue'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },

  isShowTimeWarningMessage: {
    type: Boolean,
    default: false,
  },

  disabledDate: {
    type: Function,
    default: () => null,
  },
});

const changePickupTime = () => {
  emit('change-pickup-time', props.data.pickupTime);
};

const emit = defineEmits(['change-pickup-time']);
</script>
